import $axios from "../api/accessor";
import { $api } from "../api/api";

export const FaqService = {
  async getAllFaq() {
    let response = await $axios
      .get($api("faq"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
